!function(){var e=navigator.userAgent,a=document.documentElement,n="";a.className&&(n=" "),e.match(/Trident.*rv[ :]*11\./)&&(a.className+=n+"ie11")}();